<app-shared-printer-settings #thePrinterSetting [parameters]="parameters"></app-shared-printer-settings>
